<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="subBlockContainer">
  <div class="blockContainer narrow-sidebar">
    <div class="combination-loader">
      <div class="child-sidebar sidebar-loader">
        <child-header [title]="title" (closeEvent)="navigateTo('/manageRenewalsNew')"></child-header>
        <!-- <div class="page-title-wrapper">
          <div class="title blade-title-font">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/manageRenewalsNew']">close</i>
        </div> -->
        <!-- <ng-container *ngFor="let item of MENULIST">
            <div class="menu-wrapper" [id]="item.menuRouter" [routerLink]="item.menuRouter" routerLinkActive="active">
              {{item.menuName}} </div>
          </ng-container> -->
        <div class="child-body">
          <ng-container>
            <div class="menu-wrapper small-title" routerLinkActive="active" [class.active]="isActive(partnerCSN)"
                [routerLink]="['./' + partnerName + '/' + partnerCSN]">Upcoming Opportunity
            </div>
          </ng-container>
          <div class="menu-wrapper" id="searchValue">
            <div class="searchInputGroup">
              <div class="searchIcon" (click)="search(searchField)">
                <img src="../images/new_ui/searchIcon-gray.png">
              </div>
              <ng-template #tipContent>
                <div>Type opportunity or contract number here.</div>
              </ng-template>
              <input class="searchInput" [ngbTooltip]="tipContent" placement="bottom" type="text"
                placeholder="Search By Opportunity/ Contract" onfocus="this.placeholder=''"
                onblur="this.placeholder='Search By Opportunity/ Contract'" [(ngModel)]="searchField" onfocus="this.placeholder=''" onblur="this.placeholder='Search By Opportunity/ Contract'"
                (keyup.enter)="search(searchField)">
            </div>
          </div>
        </div>
      </div>
      <div class="child-loader">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>